var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { mapState } from 'vuex';
import { checkNum, checkInteger } from '../../utils/common-utils';
import selectCustom from '../../components/console-common/select-custom.vue';
export default Vue.extend({
    name: 'planCreate',
    computed: __assign({}, mapState(['repayment']), { list: function () {
            return this.tableData;
        },
        isOpen: function () {
            return this.repayment.isOpenCreate;
        },
        alreadyCreateNewPlanAmount: function () {
            return this.repayment.alreadyCreateNewPlanAmount;
        },
        isCreate: function () {
            return this.repayment.isCreate;
        } }),
    components: {
        'el-select-add': selectCustom,
    },
    props: {
        isEffective: {
            type: Boolean,
            default: false,
        },
        contractData: {
            type: Object,
            default: function () {
                return {};
            },
        },
        tableData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        amountTypes: {
            type: Array,
            default: function () {
                return [];
            },
        },
        sureBtn: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        newPlanAmount: {
            type: String,
            default: '0',
        },
    },
    data: function () {
        var validateDate = function (rule, value, callback) {
            // const { modeType } = rule
            var startDate = new Date(value[0]).getTime();
            var endDate = new Date(value[1]).getTime();
            var nowDate = new Date();
            var now = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()).getTime();
            var dayTime = 1 * 24 * 60 * 60 * 1000;
            if (!startDate) {
                return callback(new Error('开始日期不能为空'));
            }
            if (!endDate) {
                return callback(new Error('结束日期不能为空'));
            }
            if (startDate > endDate) {
                return callback(new Error('开始日期不能大于结束日期'));
            }
            if (this.ruleForm &&
                this.ruleForm.mode !== 'ACTIVE' &&
                startDate &&
                startDate < now + dayTime) {
                return callback(new Error('日期必须大于今天'));
            }
            // if (modeType === 'now') {
            //   if (startDate < now) {
            //     return callback(new Error('日期不能早于今天'))
            //   }
            //   return callback()
            // }
            // if (modeType === 'next') {
            //   if (startDate < now + dayTime) {
            //     return callback(new Error('日期必须大于今天'))
            //   }
            //   return callback()
            // }
            callback();
        }.bind(this);
        return {
            isShowDuration: true,
            modeOptions: [
                {
                    label: '日扣优先',
                    val: 'DAY_GREED',
                    disabled: !(this.isEffective &&
                        this.contractData.signStatus === 'SIGNED' &&
                        this.contractData.newPlanAmount > 0),
                },
                {
                    label: '日扣平均',
                    val: 'DAY_AVERAGE',
                    disabled: !(this.isEffective &&
                        this.contractData.signStatus === 'SIGNED' &&
                        this.contractData.newPlanAmount > 0),
                },
                {
                    label: '主动还款',
                    val: 'ACTIVE',
                },
            ],
            ruleForm: {
                amount: '',
                mode: '',
                date: [],
                durationNo: 0,
            },
            rules: {
                amountType: [
                    { required: true, message: '请选择费用类型', trigger: 'change' },
                ],
                amount: [
                    { required: true, message: '请输入月租金/月供', trigger: 'blur' },
                    { required: true, validator: checkNum, trigger: 'blur' },
                ],
                mode: [
                    { required: true, message: '请选择扣款模式', trigger: 'change' },
                ],
                date: [
                    { required: true, message: '请输入扣款周期', trigger: 'blur' },
                    { validator: validateDate, trigger: 'change', modeType: 'now' },
                ],
                durationNo: [
                    { required: true, message: '请输入期数', trigger: 'blur' },
                    { validator: checkInteger, trigger: 'blur' },
                ],
            },
        };
    },
    created: function () { },
    mounted: function () { },
    methods: {
        cancel: function () {
            this.$store.commit('repayment/update', {
                isOpenCreate: false,
            });
        },
        changeSelect: function (val) {
            var _a = this, isEffective = _a.isEffective, contractData = _a.contractData;
            var signStatus = contractData.signStatus, newPlanAmount = contractData.newPlanAmount;
            var disabled = !(isEffective &&
                signStatus === 'SIGNED' &&
                newPlanAmount > 0);
            if (val === 'MONTHLY_RENT') {
                this.modeOptions[0].disabled = disabled;
                this.modeOptions[1].disabled = disabled;
                this.ruleForm.mode = '';
                this.rules.date[1].modeType = 'next';
                return;
            }
            this.modeOptions[0].disabled = true;
            this.modeOptions[1].disabled = true;
            this.ruleForm.mode = 'ACTIVE';
            this.rules.date[1].modeType = 'now';
        },
        createForm: function () {
            var _this = this;
            this.$refs.ruleForm.validate(function (valid) {
                if (!valid) {
                    return;
                }
                var amountTypeText = _this.tableData[0].amountTypeText;
                var _a = _this.ruleForm, durationNo = _a.durationNo, date = _a.date, mode = _a.mode, amount = _a.amount, amountType = _a.amountType;
                var formAmountTypeText = _this.ruleForm.amountTypeText;
                var completeList = null;
                if (amountTypeText) {
                    // 批量
                    var isAbleAdd = _this.$utils.toFen(amount) * durationNo <=
                        _this.$utils.toFen(_this.newPlanAmount) -
                            _this.$utils.toFen(_this.alreadyCreateNewPlanAmount);
                    if (!isAbleAdd) {
                        _this.$message({
                            message: '可用金额不足',
                            type: 'warning',
                        });
                        return;
                    }
                    completeList = [];
                    for (var i = 0; i < durationNo; i++) {
                        var eDate = _this.dateAdd(i, date);
                        // const durationNo = i + 1
                        completeList.push({
                            amountType: 'MONTHLY_RENT',
                            mode: mode,
                            amount: amount,
                            startTime: eDate[0],
                            eDate: eDate,
                            endTime: eDate[1],
                            modeType: mode === 'ACTIVE' ? 'now' : 'next',
                            isEdit: false,
                        });
                    }
                }
                else {
                    // 单个
                    completeList = {
                        amountType: amountType,
                        amountTypeText: formAmountTypeText,
                        mode: mode,
                        amount: amount,
                        eDate: date,
                        modeType: mode === 'ACTIVE' ? 'now' : 'next',
                        startTime: moment(date[0]).format('YYYY-MM-DD'),
                        endTime: moment(date[1]).format('YYYY-MM-DD'),
                        isEdit: true,
                    };
                }
                _this.$emit('get-create-data', {
                    completeList: completeList,
                });
                _this.$store.commit('repayment/update', {
                    isOpenCreate: false,
                    isCreate: true,
                });
            });
        },
        dateAdd: function (index, dateArr) {
            var arr = [];
            var isLeapYear = function (Year) {
                if ((Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0) {
                    return true;
                }
                else {
                    return false;
                }
            };
            dateArr.forEach(function (item) {
                var itemDate = moment(item).format('YYYY-MM-DD');
                var inputDate = itemDate.split('-');
                var date = new Date(Number.parseInt(inputDate[0]), Number.parseInt(inputDate[1]) - 1, 1);
                var mon = Number(date.getMonth());
                var day = inputDate[2];
                date.setMonth(mon + index, 1);
                var mo = date.getMonth() + 1;
                // 读取日期自动会减一，所以要加一
                // 小月
                if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
                    if (+day > 30) {
                        day = "" + 30;
                    }
                }
                else if (mo === 2) {
                    // 2月
                    if (isLeapYear(date.getFullYear())) {
                        if (+day > 29) {
                            day = "" + 29;
                        }
                    }
                    if (+day > 28) {
                        day = "" + 28;
                    }
                }
                else {
                    if (+day > 31) {
                        day = "" + 31;
                    }
                }
                arr.push(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + day);
            });
            return arr;
        },
        getMode: function (val) {
            val === 'ACTIVE'
                ? (this.rules.date[1].modeType = 'now')
                : (this.rules.date[1].modeType = 'next');
            this.$refs['ruleForm'].validateField('date', function (errorMsg) {
                if (errorMsg !== '') {
                    return false;
                }
            });
        },
    },
    watch: {
        isOpen: function (val) {
            if (val) {
                var amountTypeText = this.tableData[0].amountTypeText;
                var _a = this.contractData, monthlyPayment = _a.monthlyPayment, repayStartTime = _a.repayStartTime, totalDuration = _a.totalDuration;
                this.rules.date[1].modeType = 'now';
                this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields();
                if (amountTypeText) {
                    this.isShowDuration = true;
                }
                else {
                    this.isShowDuration = false;
                }
                if (amountTypeText && !this.isCreate) {
                    this.ruleForm = {
                        amount: this.$utils.toYuan(monthlyPayment),
                        mode: '',
                        date: [moment(repayStartTime).format('YYYY-MM-DD'), ''],
                        durationNo: totalDuration,
                    };
                    return;
                }
                this.ruleForm = {
                    amount: '',
                    mode: '',
                    date: [],
                    durationNo: 0,
                };
            }
        },
    },
});
